import { ContentChild, Directive, Input, TemplateRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

/**
 * Der Template-Kontext für ein Cell-Template.
 */
export interface TableCellContext {
    /**
     * Die Daten für die aktuell anzuzueigende Zeile.
     */
    $implicit: any;

    /**
     * Der Index der aktuell anzuzeigenden Zeile. Startet mit 0.
     */
    index: number;
}

/**
 * Direktive, um ein Template für die Darstellung einer Tabellen-Zelle in einer bestimmten Tabellenspalte bereitzustellen.
 */
@Directive({ selector: '[tableCell]' })
export class TableCellDirective {
    constructor(public template: TemplateRef<TableCellContext>) { }
}

/**
 * Der Template-Kontext für ein FilterCell-Template.
 */
export interface TableFilterCellContext {
    /**
     * Das FormControl, das den aktuellen Wert des Filters beinhaltet.
     * Als Wert ist folgendes erlaubt:
     * - string, number, Date,
     * - Object (flach, mit Properties vom Typ string number oder Date)
     * - ein Array der vorgenannten Werte (Multiselektion mit ODER-Semantik)
     */
    $implicit: UntypedFormControl;
}

/**
 * Direktive, um ein Template für die Darstellung eines Filters für eine Tabellenspalte bereitzustellen.
 */
@Directive({ selector: '[tableFilterCell]' })
export class TableFilterCellDirective {
    constructor(public template: TemplateRef<TableFilterCellContext>) { }
}

/**
 * Direktive, um Templates für die Darstellung einer Tabellenspalte bereitzustellen.
 */
@Directive({ selector: '[tableColumn]' })
export class TableColumnDirective {

    /**
     * Eindeutiger Name der Spalte.
     */
    @Input('tableColumn')
    name: string;

    /**
     * Das Template für die Darstellung der Tabellen-Zelle.
     */
    @ContentChild(TableCellDirective) cell: TableCellDirective;

    /**
     * Das Template für die Darstellung der Filter-Zelle.
     */
    @ContentChild(TableFilterCellDirective) filter: TableFilterCellDirective;

}
